<template>
    <div class="row p-5">
        <div>
            <h2>{{ $t("warehouses.createProduct") }}</h2>
        </div>
        <div v-if="error" class="alert alert-danger mt-3" role="alert">
            {{ error }}
        </div>
        <div class="mt-3">
            <form @submit.prevent="submitCreation">
                <div class="row w-50">
                    <div class="col-12 colg-6 box d-flex flex-column">
                        <label for="productSelect" class="form-label">{{ $t("products.enterOutput") }}</label>
                        <select v-model="postData.selectedProduct" class="form-control form-select" id="productSelect"
                            name="productSelect" size="1">
                            <option v-for="product in products" :key="product.id" :value="product.id">
                                {{ product.name }} ( {{ product.shorten_name }} )
                            </option>
                        </select>
                    </div>
                    <div class="col-12 colg-6 mt-3">
                        <label for="countInput" class="form-label">{{ $t("products.amountPieces") }}</label>
                        <input v-model.number="postData.count" type="number" name="count" class="form-control"
                            id="countInput" />
                    </div>
                    <div class="col-12 mt-4" v-if="!error">
                        <button type="submit" class="btn btn-primary text-white px-5 fw-bold">
                            {{ $t("utils.create") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

export default {
    components: {

    },
    data() {
        return {
            products: [],
            availableConversions: [],
            postData: {
                selectedProduct: null,
                count: 0
            },
            error: null
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/unhidden_products").then((response) => {
                this.products = response.data.items
            })
            this.$store.getters.api.get("/product_conversions").then((response) => {
                this.availableConversions = response.data.items
            })
        },

        submitCreation() {
            this.$store.getters.api.put("/warehouse/" + this.$route.params.id + "/product_conversion/submit", this.postData
            ).then((response) => {
                this.$router.push({ name: "WarehouseStock", params: { id: this.$route.params.id } })
            });
        }
    },
    watch: {
        'postData.selectedProduct'(newVal) {
            this.error = null;
            if (
                !this.availableConversions.find(
                    conversion => conversion.output_product === newVal
                )
            ) {
                this.error = this.$t("products.noConversionForProduct");
            }
        }
    }
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";
</style>